// extracted by mini-css-extract-plugin
module.exports = {"Outline":"InfoOutline_Outline__1uqi7","description":"InfoOutline_description__UuwNG","ShowDetail":"InfoOutline_ShowDetail__2dqk7"};